import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';

import PrimeVue from 'primevue/config';
import { definePreset, updateSurfacePalette } from '@primevue/themes';
import Aura from '@primevue/themes/aura';
import Lara from '@primevue/themes/lara';
import Nora from '@primevue/themes/nora';
import CLara from '@/assets/themes/custom-lara';
//import CNora from '@/assets/themes/custom-nora';

import { useThemeStore } from './stores/themeStore';
import { loadLayoutConfig } from '@/layout/composables/layout';
import ToastService from 'primevue/toastservice';
import Toast from 'primevue/toast';
import ConfirmationService from 'primevue/confirmationservice';
//import TerminalService from "primevue/terminalservice";
import BlockViewer from '@/components/BlockViewer.vue';

import '@/assets/styles.scss';
import '@/assets/tailwind.css';
import { logger } from '@/config/logger';  // logger 초기화

// survey-vue 관련 import
import 'survey-core/survey-core.min.css';
import { surveyPlugin } from 'survey-vue3-ui';

import print from 'vue3-print-nb';

//import { register } from 'vue-advanced-chat';
//register();

const savedConfig = loadLayoutConfig(); // 저장된 설정 불러오기

// 기본 테마 선택
//const presetThemes = { Aura, Lara, Nora, CNora, CLara };
const presetThemes = { Aura, Lara, Nora, CLara };
const initialPreset = presetThemes[savedConfig.preset] || CLara;

// PrimeVue Preset 생성
const customPreset = definePreset(initialPreset, {
  semantic: {
    primary: {
      50: `{${savedConfig.primary}.50}`,
      100: `{${savedConfig.primary}.100}`,
      200: `{${savedConfig.primary}.200}`,
      300: `{${savedConfig.primary}.300}`,
      400: `{${savedConfig.primary}.400}`,
      500: `{${savedConfig.primary}.500}`,
      600: `{${savedConfig.primary}.600}`,
      700: `{${savedConfig.primary}.700}`,
      800: `{${savedConfig.primary}.800}`,
      900: `{${savedConfig.primary}.900}`,
      950: `{${savedConfig.primary}.950}`,
    },
  },
});

// const surfaces = [
//   {
//     name: 'slate',
//     palette: {
//       0: '#ffffff',
//       50: '#f8fafc',
//       100: '#f1f5f9',
//       200: '#e2e8f0',
//       300: '#cbd5e1',
//       400: '#94a3b8',
//       500: '#64748b',
//       600: '#475569',
//       700: '#334155',
//       800: '#1e293b',
//       900: '#0f172a',
//       950: '#020617',
//     },
//   },
//   {
//     name: 'gray',
//     palette: {
//       0: '#ffffff',
//       50: '#f9fafb',
//       100: '#f3f4f6',
//       200: '#e5e7eb',
//       300: '#d1d5db',
//       400: '#9ca3af',
//       500: '#6b7280',
//       600: '#4b5563',
//       700: '#374151',
//       800: '#1f2937',
//       900: '#111827',
//       950: '#030712',
//     },
//   },
//   {
//     name: 'zinc',
//     palette: {
//       0: '#ffffff',
//       50: '#fafafa',
//       100: '#f4f4f5',
//       200: '#e4e4e7',
//       300: '#d4d4d8',
//       400: '#a1a1aa',
//       500: '#71717a',
//       600: '#52525b',
//       700: '#3f3f46',
//       800: '#27272a',
//       900: '#18181b',
//       950: '#09090b',
//     },
//   },
//   {
//     name: 'neutral',
//     palette: {
//       0: '#ffffff',
//       50: '#fafafa',
//       100: '#f5f5f5',
//       200: '#e5e5e5',
//       300: '#d4d4d4',
//       400: '#a3a3a3',
//       500: '#737373',
//       600: '#525252',
//       700: '#404040',
//       800: '#262626',
//       900: '#171717',
//       950: '#0a0a0a',
//     },
//   },
//   {
//     name: 'stone',
//     palette: {
//       0: '#ffffff',
//       50: '#fafaf9',
//       100: '#f5f5f4',
//       200: '#e7e5e4',
//       300: '#d6d3d1',
//       400: '#a8a29e',
//       500: '#78716c',
//       600: '#57534e',
//       700: '#44403c',
//       800: '#292524',
//       900: '#1c1917',
//       950: '#0c0a09',
//     },
//   },
//   {
//     name: 'soho',
//     palette: {
//       0: '#ffffff',
//       50: '#f4f4f4',
//       100: '#e8e9e9',
//       200: '#d2d2d4',
//       300: '#bbbcbe',
//       400: '#a5a5a9',
//       500: '#8e8f93',
//       600: '#77787d',
//       700: '#616268',
//       800: '#4a4b52',
//       900: '#34343d',
//       950: '#1d1e27',
//     },
//   },
//   {
//     name: 'viva',
//     palette: {
//       0: '#ffffff',
//       50: '#f3f3f3',
//       100: '#e7e7e8',
//       200: '#cfd0d0',
//       300: '#b7b8b9',
//       400: '#9fa1a1',
//       500: '#87898a',
//       600: '#6e7173',
//       700: '#565a5b',
//       800: '#3e4244',
//       900: '#262b2c',
//       950: '#0e1315',
//     },
//   },
//   {
//     name: 'ocean',
//     palette: {
//       0: '#ffffff',
//       50: '#fbfcfc',
//       100: '#F7F9F8',
//       200: '#EFF3F2',
//       300: '#DADEDD',
//       400: '#B1B7B6',
//       500: '#828787',
//       600: '#5F7274',
//       700: '#415B61',
//       800: '#29444E',
//       900: '#183240',
//       950: '#0c1920',
//     },
//   },
// ];
const surfaces = [
  {
    name: 'slate',
    palette: {
      0: '#ffffff',
      50: '#f8fafc',
      100: '#f1f5f9',
      200: '#e2e8f0',
      300: '#cbd5e1',
      400: '#94a3b8',
      500: '#64748b',
      600: '#475569',
      700: '#334155',
      800: '#1e293b',
      900: '#0f172a',
      950: '#020617',
    },
  },
  {
    name: 'zinc',
    palette: {
      0: '#ffffff',
      50: '#fafafa',
      100: '#f4f4f5',
      200: '#e4e4e7',
      300: '#d4d4d8',
      400: '#a1a1aa',
      500: '#71717a',
      600: '#52525b',
      700: '#3f3f46',
      800: '#27272a',
      900: '#18181b',
      950: '#09090b',
    },
  },
  {
    name: 'viva',
    palette: {
      0: '#ffffff',
      50: '#f3f3f3',
      100: '#e7e7e8',
      200: '#cfd0d0',
      300: '#b7b8b9',
      400: '#9fa1a1',
      500: '#87898a',
      600: '#6e7173',
      700: '#565a5b',
      800: '#3e4244',
      900: '#262b2c',
      950: '#0e1315',
    },
  },
  {
    name: 'paper', // 종이같은 따뜻한 화이트
    palette: {
      0: '#ffffff',
      50: '#fdfbf7',
      100: '#faf7f0',
      200: '#f5efe2',
      300: '#ebe2d3',
      400: '#dccebe',
      500: '#c4b5a1',
      600: '#a69882',
      700: '#887964',
      800: '#665a49',
      900: '#4a4035',
      950: '#2b251f',
    },
  },
  {
    name: 'steel', // 차가운 메탈릭
    palette: {
      0: '#ffffff',
      50: '#f8fafb',
      100: '#f0f4f8',
      200: '#e2eaf1',
      300: '#cedbe7',
      400: '#b0c4d7',
      500: '#8ea8c2',
      600: '#6d89a3',
      700: '#516b85',
      800: '#3a4f64',
      900: '#2a394a',
      950: '#1a242f',
    },
  },
  {
    name: 'dust', // 부드러운 그레이
    palette: {
      0: '#ffffff',
      50: '#fbfbfa',
      100: '#f6f6f3',
      200: '#ebeae4',
      300: '#dbd9d0',
      400: '#c2beb2',
      500: '#a5a093',
      600: '#878273',
      700: '#696557',
      800: '#4d4a40',
      900: '#363430',
      950: '#201f1c',
    },
  },
  {
    name: 'mint', // 민트 느낌의 시원한 색조
    palette: {
      0: '#ffffff',
      50: '#f6fbfa',
      100: '#ecf7f4',
      200: '#daf0eb',
      300: '#c2e4dc',
      400: '#9ed3c7',
      500: '#7abab0',
      600: '#589b93',
      700: '#417b74',
      800: '#2f5b56',
      900: '#234440',
      950: '#152a27',
    },
  },
  {
    name: 'dusk', // 황혼빛 느낌
    palette: {
      0: '#ffffff',
      50: '#faf9fb',
      100: '#f4f1f8',
      200: '#e7e1ef',
      300: '#d5cce2',
      400: '#baaed0',
      500: '#9c8db8',
      600: '#7d6c9a',
      700: '#614f7c',
      800: '#48395d',
      900: '#352a45',
      950: '#221b2d',
    },
  },
  {
    name: 'sand', // 따뜻한 샌드톤
    palette: {
      0: '#ffffff',
      50: '#fdfaf6',
      100: '#fbf3ea',
      200: '#f5e5d4',
      300: '#ecd1b9',
      400: '#ddb594',
      500: '#cb966e',
      600: '#b27750',
      700: '#8f5b3d',
      800: '#6c442f',
      900: '#4f3226',
      950: '#2d1d16',
    },
  },
];

const app = createApp(App);
const pinia = createPinia();

app.use(router);
app.use(pinia);
// themeStore 초기화
//const themeStore = useThemeStore();

app.use(PrimeVue, {
  theme: {
    preset: customPreset,
    options: {
      darkModeSelector: '.app-dark',
    },
  },
  locale: {
    // 주의: 한국에서는 일반적으로 월요일이 한 주의 시작입니다.
    firstDayOfWeek: 1,
    dayNames: [
      '일요일',
      '월요일',
      '화요일',
      '수요일',
      '목요일',
      '금요일',
      '토요일',
    ],
    dayNamesShort: ['일', '월', '화', '수', '목', '금', '토'],
    dayNamesMin: ['일', '월', '화', '수', '목', '금', '토'],
    monthNames: [
      '1월',
      '2월',
      '3월',
      '4월',
      '5월',
      '6월',
      '7월',
      '8월',
      '9월',
      '10월',
      '11월',
      '12월',
    ],
    monthNamesShort: [
      '1월',
      '2월',
      '3월',
      '4월',
      '5월',
      '6월',
      '7월',
      '8월',
      '9월',
      '10월',
      '11월',
      '12월',
    ],
    today: '오늘',
    clear: '초기화',
  },
});

// savedConfig의 surface 값에 해당하는 팔레트 찾기
if (savedConfig.surface) {
  const selectedSurface = surfaces.find((s) => s.name === savedConfig.surface);
  if (selectedSurface) {
    updateSurfacePalette(selectedSurface.palette);
  }
}

app.use(ToastService);

app.component('Toast', Toast);

app.use(ConfirmationService);
//app.use(TerminalService);
app.component('BlockViewer', BlockViewer);

// Survey 컴포넌트 전역 등록
app.use(surveyPlugin);
app.use(print);

// Pinia 스토어에 router 주입 스토어에 들어간 모든것에 router를 주입하게 된다.
pinia.use(({ store }) => {
  store.router = router;
});

app.mount('#app');
